import React from 'react';
import range from 'lodash/range';
import NumberPadButton from './NumberPadButton';
import GoButton from './GoButton';
import { remCalc } from '../../util/style-util';
import { makeStyles } from '@mui/styles';

type Props = {
  makeKeyInputHandler: (inputNumber: string) => (e: Event) => void;
  newPage: string;
  handleGoClick: () => void;
} & any;

const useStyles = makeStyles(() => ({
  keypad: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    width: remCalc(240),
    margin: '0 auto'
  },
  keypadButton: {
    flex: 1,
    userSelect: 'none'
  }
}));

const Keypad = ({ makeKeyInputHandler, newPage, handleGoClick }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.keypad}>
      {[...range(1, 10), 0].map(i => (
        <NumberPadButton
          number={i}
          buttonStyles={classes.keypadButton}
          onClick={makeKeyInputHandler(i.toString())}
          key={i}
        />
      ))}
      <GoButton onClick={handleGoClick} disabled={!newPage} buttonStyles={classes.keypadButton} />
    </div>
  );
};

export default Keypad;
